declare var get_logrocket_configuration;
declare var bugsnag;

import { load_js_async } from './utils.js';

const logrocket_url = 'https://cdn.ingest-lr.com/LogRocket.min.js';
const bugsnag_url = '//d2wy8f7a9ursnm.cloudfront.net/v5/bugsnag.min.js';

async function optionally_load_js_async(url: string, enabled: boolean, anonymous: boolean = false): Promise<boolean> {
    if (!enabled) {
        return false;
    }
    return load_js_async(url, anonymous);
}
export async function init_logrocket() {
    const config = get_logrocket_configuration();
    const [logrocket_loaded, bugsnag_loaded] = await Promise.all([
        optionally_load_js_async(logrocket_url, config.log_rocket.enabled, true),
        optionally_load_js_async(bugsnag_url, config.bugsnag.enabled),
    ]);

    if (logrocket_loaded) {
        (window as any).LogRocket.init(config.log_rocket.environment, {
            network: {
                requestSanitizer: function(request) {
                    for(const url of config.log_rocket.ignore_network_urls) {
                        if (request.url.toLowerCase().indexOf(url) !== -1) {
                            return null;
                        }
                    }
                    return request;
                }
            },
            release: config.log_rocket.release
        });

        if ((window as any).LogRocket.identify && config.user_data.user_id > 0) {
            (window as any).LogRocket.identify(config.user_data.user_id, config.user_data);
        }
    }

    if (bugsnag_loaded) {
       const options = {
            apiKey: config.bugsnag.apiKey,
            beforeSend: function(report) {
                report.metaData.sessionURL = logrocket_loaded ? (window as any).LogRocket.sessionURL : '';
            },
            filters: [
                /^password$/i,
                /^cc_/,
                /^credit_card/i
            ],
            logger: null,
            notifyReleaseStages: [
                'production',
                'staging',
                'development'
            ],
            releaseStage: config.bugsnag.releaseStage,
            appVersion: config.bugsnag.appVersion
        };

        const bugsnagClient = bugsnag(options);
        bugsnagClient.user = config.user_data;
        bugsnagClient.metaData = {
            sessionURL: logrocket_loaded ? (window as any).LogRocket.sessionURL : ''
        };
        (window as any).bugsnagClient = bugsnagClient;
    }
}
